import { render, staticRenderFns } from "./UserModulesCrm.vue?vue&type=template&id=734b9b37&"
import script from "./UserModulesCrm.vue?vue&type=script&lang=js&"
export * from "./UserModulesCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports